import { Observable } from 'rxjs'
import { Salutation } from '../../../models'

export abstract class MbSalutationAdapter {

  abstract load(): Observable<Salutation[]>
}
